import { useEffect, useState } from "react";
import type { ReactNode } from "react";

interface I18nProviderProps {
  children: ReactNode;
  fallback?: ReactNode;
}

const loadI18n = () => import("./index");

export const I18nProvider = ({ children, fallback = null }: I18nProviderProps) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;

    loadI18n()
      .then(() => {
        if (active) {
          setReady(true);
        }
      })
      .catch((error) => {
        console.error("Failed to load i18n resources:", error);
        if (active) {
          setReady(true);
        }
      });

    return () => {
      active = false;
    };
  }, []);

  if (!ready) {
    return fallback;
  }

  return <>{children}</>;
};
